/* 🤖 this file was generated by svg-to-ts */
import { SiriusIcon } from './sirius-icons.model';
import { siriusApplePodcastsLogoDuotone } from './sirius-apple-podcasts-logo-duotone.icon';
import { siriusArrowFatLinesRightDuotone } from './sirius-arrow-fat-lines-right-duotone.icon';
import { siriusBarbellDuotone } from './sirius-barbell-duotone.icon';
import { siriusBarcodeDuotone } from './sirius-barcode-duotone.icon';
import { siriusBellDuotone } from './sirius-bell-duotone.icon';
import { siriusBinocularsDuotone } from './sirius-binoculars-duotone.icon';
import { siriusBookOpenTextDuotone } from './sirius-book-open-text-duotone.icon';
import { siriusBookmarkSimpleDuotone } from './sirius-bookmark-simple-duotone.icon';
import { siriusBooksDuotone } from './sirius-books-duotone.icon';
import { siriusBriefcaseDuotone } from './sirius-briefcase-duotone.icon';
import { siriusBugDuotone } from './sirius-bug-duotone.icon';
import { siriusCalendarBlankDuotone } from './sirius-calendar-blank-duotone.icon';
import { siriusChartBarHorizontalDuotone } from './sirius-chart-bar-horizontal-duotone.icon';
import { siriusChartBarVerticalDuotone } from './sirius-chart-bar-vertical-duotone.icon';
import { siriusChartLineUpDuotone } from './sirius-chart-line-up-duotone.icon';
import { siriusChatCenteredDuotone } from './sirius-chat-centered-duotone.icon';
import { siriusChatCenteredTextDuotone } from './sirius-chat-centered-text-duotone.icon';
import { siriusChatsDuotone } from './sirius-chats-duotone.icon';
import { siriusCheckCircleDuotone } from './sirius-check-circle-duotone.icon';
import { siriusCircleHalfTiltDuotone } from './sirius-circle-half-tilt-duotone.icon';
import { siriusClipboardPlusDuotone } from './sirius-clipboard-plus-duotone.icon';
import { siriusClipboardTextDuotone } from './sirius-clipboard-text-duotone.icon';
import { siriusClockDuotone } from './sirius-clock-duotone.icon';
import { siriusClosedCaptioningDuotone } from './sirius-closed-captioning-duotone.icon';
import { siriusCloudArrowDownDuotone } from './sirius-cloud-arrow-down-duotone.icon';
import { siriusCloudArrowUpDuotone } from './sirius-cloud-arrow-up-duotone.icon';
import { siriusCloudCheckDuotone } from './sirius-cloud-check-duotone.icon';
import { siriusCloudDuotone } from './sirius-cloud-duotone.icon';
import { siriusCobotLineDuotone } from './sirius-cobot-line-duotone.icon';
import { siriusCodepenLogoDuotone } from './sirius-codepen-logo-duotone.icon';
import { siriusCookieDuotone } from './sirius-cookie-duotone.icon';
import { siriusCopyDuotone } from './sirius-copy-duotone.icon';
import { siriusCopyrightDuotone } from './sirius-copyright-duotone.icon';
import { siriusCreditCardDuotone } from './sirius-credit-card-duotone.icon';
import { siriusCropDuotone } from './sirius-crop-duotone.icon';
import { siriusCrosshairDuotone } from './sirius-crosshair-duotone.icon';
import { siriusCubeDuotone } from './sirius-cube-duotone.icon';
import { siriusCurrencyDollarSimpleDuotone } from './sirius-currency-dollar-simple-duotone.icon';
import { siriusCylinderDuotone } from './sirius-cylinder-duotone.icon';
import { siriusDatabaseDuotone } from './sirius-database-duotone.icon';
import { siriusDesktopDuotone } from './sirius-desktop-duotone.icon';
import { siriusDeviceDuotone } from './sirius-device-duotone.icon';
import { siriusDotsThreeHorisontalDuotone } from './sirius-dots-three-horisontal-duotone.icon';
import { siriusDotsThreeVerticalDuotone } from './sirius-dots-three-vertical-duotone.icon';
import { siriusDropDuotone } from './sirius-drop-duotone.icon';
import { siriusEnvelopeOpenDuotone } from './sirius-envelope-open-duotone.icon';
import { siriusEraserDuotone } from './sirius-eraser-duotone.icon';
import { siriusEyeDuotone } from './sirius-eye-duotone.icon';
import { siriusEyeSlashDuotone } from './sirius-eye-slash-duotone.icon';
import { siriusEyecClosedDuotone } from './sirius-eyec-closed-duotone.icon';
import { siriusFacebookLogoDuotone } from './sirius-facebook-logo-duotone.icon';
import { siriusFileArrowDownDuotone } from './sirius-file-arrow-down-duotone.icon';
import { siriusFileArrowUpDuotone } from './sirius-file-arrow-up-duotone.icon';
import { siriusFileDocDuotone } from './sirius-file-doc-duotone.icon';
import { siriusFileHtmlDuotone } from './sirius-file-html-duotone.icon';
import { siriusFileJpgDuotone } from './sirius-file-jpg-duotone.icon';
import { siriusFilePdfDuotone } from './sirius-file-pdf-duotone.icon';
import { siriusFilePngDuotone } from './sirius-file-png-duotone.icon';
import { siriusFilePptDuotone } from './sirius-file-ppt-duotone.icon';
import { siriusFileXlsDuotone } from './sirius-file-xls-duotone.icon';
import { siriusFileZipDuotone } from './sirius-file-zip-duotone.icon';
import { siriusFlameDuotone } from './sirius-flame-duotone.icon';
import { siriusFlaskDuotone } from './sirius-flask-duotone.icon';
import { siriusForkKnifeDuotone } from './sirius-fork-knife-duotone.icon';
import { siriusFunnelDuotone } from './sirius-funnel-duotone.icon';
import { siriusGaugeDuotone } from './sirius-gauge-duotone.icon';
import { siriusGearDuotone } from './sirius-gear-duotone.icon';
import { siriusGhostDuotone } from './sirius-ghost-duotone.icon';
import { siriusGitBranchDuotone } from './sirius-git-branch-duotone.icon';
import { siriusGitForkDuotone } from './sirius-git-fork-duotone.icon';
import { siriusGlobeDuotone } from './sirius-globe-duotone.icon';
import { siriusGlobeStandDuotone } from './sirius-globe-stand-duotone.icon';
import { siriusGraduationCapDuotone } from './sirius-graduation-cap-duotone.icon';
import { siriusGraphDuotone } from './sirius-graph-duotone.icon';
import { siriusHandshakeDuotone } from './sirius-handshake-duotone.icon';
import { siriusHeadsetDuotone } from './sirius-headset-duotone.icon';
import { siriusHeartDuotone } from './sirius-heart-duotone.icon';
import { siriusHeartbeatDuotone } from './sirius-heartbeat-duotone.icon';
import { siriusHouseDuotone } from './sirius-house-duotone.icon';
import { siriusImageDuotone } from './sirius-image-duotone.icon';
import { siriusInfoDuotone } from './sirius-info-duotone.icon';
import { siriusInstagramLogoDuotone } from './sirius-instagram-logo-duotone.icon';
import { siriusLeafDuotone } from './sirius-leaf-duotone.icon';
import { siriusLinkedinLogoDuotone } from './sirius-linkedin-logo-duotone.icon';
import { siriusListBulletsDuotone } from './sirius-list-bullets-duotone.icon';
import { siriusListChecksDuotone } from './sirius-list-checks-duotone.icon';
import { siriusListPlusDuotone } from './sirius-list-plus-duotone.icon';
import { siriusLockSimpleDuotone } from './sirius-lock-simple-duotone.icon';
import { siriusLockSimpleOpenDuotone } from './sirius-lock-simple-open-duotone.icon';
import { siriusMagnifyingGlassDuotone } from './sirius-magnifying-glass-duotone.icon';
import { siriusMagnifyingGlassMinusDuotone } from './sirius-magnifying-glass-minus-duotone.icon';
import { siriusMagnifyingGlassPlusDuotone } from './sirius-magnifying-glass-plus-duotone.icon';
import { siriusMapPinDuotone } from './sirius-map-pin-duotone.icon';
import { siriusMonitorDuotone } from './sirius-monitor-duotone.icon';
import { siriusMoonDuotone } from './sirius-moon-duotone.icon';
import { siriusNeedleDuotone } from './sirius-needle-duotone.icon';
import { siriusNotepadDuotone } from './sirius-notepad-duotone.icon';
import { siriusNutDuotone } from './sirius-nut-duotone.icon';
import { siriusPackageDuotone } from './sirius-package-duotone.icon';
import { siriusPaintBrushBroadDuotone } from './sirius-paint-brush-broad-duotone.icon';
import { siriusPencilDuotone } from './sirius-pencil-duotone.icon';
import { siriusPencilRulerDuotone } from './sirius-pencil-ruler-duotone.icon';
import { siriusPersonSimpleCircleDuotone } from './sirius-person-simple-circle-duotone.icon';
import { siriusPlayCircleDuotone } from './sirius-play-circle-duotone.icon';
import { siriusPlugsConnectedDuotone } from './sirius-plugs-connected-duotone.icon';
import { siriusPlugsDuotone } from './sirius-plugs-duotone.icon';
import { siriusPrinterDuotone } from './sirius-printer-duotone.icon';
import { siriusQuestionDuotone } from './sirius-question-duotone.icon';
import { siriusQuotesDuotone } from './sirius-quotes-duotone.icon';
import { siriusRepeatDuotone } from './sirius-repeat-duotone.icon';
import { siriusRobotDuotone } from './sirius-robot-duotone.icon';
import { siriusRocketLaunchDuotone } from './sirius-rocket-launch-duotone.icon';
import { siriusRowsDuotone } from './sirius-rows-duotone.icon';
import { siriusRulerDuotone } from './sirius-ruler-duotone.icon';
import { siriusScalesDuotone } from './sirius-scales-duotone.icon';
import { siriusSelectionBackgroundDuotone } from './sirius-selection-background-duotone.icon';
import { siriusShareNetworkDuotone } from './sirius-share-network-duotone.icon';
import { siriusShieldCheckDuotone } from './sirius-shield-check-duotone.icon';
import { siriusShieldDuotone } from './sirius-shield-duotone.icon';
import { siriusShipinhaoLogoDuotone } from './sirius-shipinhao-logo-duotone.icon';
import { siriusShoppingCartDuotone } from './sirius-shopping-cart-duotone.icon';
import { siriusShuffleDuotone } from './sirius-shuffle-duotone.icon';
import { siriusShuffleUpDuotone } from './sirius-shuffle-up-duotone.icon';
import { siriusSlidersHorizontalDuotone } from './sirius-sliders-horizontal-duotone.icon';
import { siriusSlidersVerticalDuotone } from './sirius-sliders-vertical-duotone.icon';
import { siriusSmalldotsThreeHorisontalDuotone } from './sirius-smalldots-three-horisontal-duotone.icon';
import { siriusSmalldotsThreeVerticalDuotone } from './sirius-smalldots-three-vertical-duotone.icon';
import { siriusSparkleDuotone } from './sirius-sparkle-duotone.icon';
import { siriusSpeakerHighDuotone } from './sirius-speaker-high-duotone.icon';
import { siriusSpeakerSlashDuotone } from './sirius-speaker-slash-duotone.icon';
import { siriusSpeakerXDuotone } from './sirius-speaker-x-duotone.icon';
import { siriusSpeedHighDuotone } from './sirius-speed-high-duotone.icon';
import { siriusSpeedLowDuotone } from './sirius-speed-low-duotone.icon';
import { siriusSpeedMediumDuotone } from './sirius-speed-medium-duotone.icon';
import { siriusSpotifyLogoDuotone } from './sirius-spotify-logo-duotone.icon';
import { siriusSquareHalfHorisontalDuotone } from './sirius-square-half-horisontal-duotone.icon';
import { siriusSquareHalfVerticalDuotone } from './sirius-square-half-vertical-duotone.icon';
import { siriusSquaresFourDuotone } from './sirius-squares-four-duotone.icon';
import { siriusStackDuotone } from './sirius-stack-duotone.icon';
import { siriusStampDuotone } from './sirius-stamp-duotone.icon';
import { siriusStarDuotone } from './sirius-star-duotone.icon';
import { siriusStickerDuotone } from './sirius-sticker-duotone.icon';
import { siriusStudentDuotone } from './sirius-student-duotone.icon';
import { siriusSunDuotone } from './sirius-sun-duotone.icon';
import { siriusSwapDuotone } from './sirius-swap-duotone.icon';
import { siriusSwatchesDuotone } from './sirius-swatches-duotone.icon';
import { siriusSyringeDuotone } from './sirius-syringe-duotone.icon';
import { siriusTagDuotone } from './sirius-tag-duotone.icon';
import { siriusTargetDuotone } from './sirius-target-duotone.icon';
import { siriusTelegramLogoDuotone } from './sirius-telegram-logo-duotone.icon';
import { siriusTestTubeDuotone } from './sirius-test-tube-duotone.icon';
import { siriusThermometerSimpleDuotone } from './sirius-thermometer-simple-duotone.icon';
import { siriusThumbsDownDuotone } from './sirius-thumbs-down-duotone.icon';
import { siriusThumbsUpDuotone } from './sirius-thumbs-up-duotone.icon';
import { siriusTicketDuotone } from './sirius-ticket-duotone.icon';
import { siriusTiktokLogoDuotone } from './sirius-tiktok-logo-duotone.icon';
import { siriusTimerDuotone } from './sirius-timer-duotone.icon';
import { siriusTrashDuotone } from './sirius-trash-duotone.icon';
import { siriusTreeDuotone } from './sirius-tree-duotone.icon';
import { siriusTreeEvergreenDuotone } from './sirius-tree-evergreen-duotone.icon';
import { siriusTruckDuotone } from './sirius-truck-duotone.icon';
import { siriusTwitterLogoDuotone } from './sirius-twitter-logo-duotone.icon';
import { siriusUserCircleDuotone } from './sirius-user-circle-duotone.icon';
import { siriusUserDuotone } from './sirius-user-duotone.icon';
import { siriusUserMinusDuotone } from './sirius-user-minus-duotone.icon';
import { siriusUserPlusDuotone } from './sirius-user-plus-duotone.icon';
import { siriusUsersFourDuotone } from './sirius-users-four-duotone.icon';
import { siriusUsersThreeDuotone } from './sirius-users-three-duotone.icon';
import { siriusUsersTwoDuotone } from './sirius-users-two-duotone.icon';
import { siriusWarningCircleDuotone } from './sirius-warning-circle-duotone.icon';
import { siriusWechatLogoDuotone } from './sirius-wechat-logo-duotone.icon';
import { siriusWeishiLogoDuotone } from './sirius-weishi-logo-duotone.icon';
import { siriusWorldDuotone } from './sirius-world-duotone.icon';
import { siriusWrenchDuotone } from './sirius-wrench-duotone.icon';
import { siriusXCircleDuotone } from './sirius-x-circle-duotone.icon';
import { siriusXLogoDuotone } from './sirius-x-logo-duotone.icon';
import { siriusYoutubeLogoDuotone } from './sirius-youtube-logo-duotone.icon';
import { siriusApplePodcastsLogo } from './sirius-apple-podcasts-logo.icon';
import { siriusArrowDownLeftSmall } from './sirius-arrow-down-left-small.icon';
import { siriusArrowDownLeft } from './sirius-arrow-down-left.icon';
import { siriusArrowDownRightSmall } from './sirius-arrow-down-right-small.icon';
import { siriusArrowDownRight } from './sirius-arrow-down-right.icon';
import { siriusArrowDownSmall } from './sirius-arrow-down-small.icon';
import { siriusArrowDown } from './sirius-arrow-down.icon';
import { siriusArrowFatLinesRight } from './sirius-arrow-fat-lines-right.icon';
import { siriusArrowLeftSmall } from './sirius-arrow-left-small.icon';
import { siriusArrowLeft } from './sirius-arrow-left.icon';
import { siriusArrowRightSmall } from './sirius-arrow-right-small.icon';
import { siriusArrowRight } from './sirius-arrow-right.icon';
import { siriusArrowSquareIn } from './sirius-arrow-square-in.icon';
import { siriusArrowSquareOut } from './sirius-arrow-square-out.icon';
import { siriusArrowUpLeftSmall } from './sirius-arrow-up-left-small.icon';
import { siriusArrowUpLeft } from './sirius-arrow-up-left.icon';
import { siriusArrowUpRightSmall } from './sirius-arrow-up-right-small.icon';
import { siriusArrowUpRight } from './sirius-arrow-up-right.icon';
import { siriusArrowUpSmall } from './sirius-arrow-up-small.icon';
import { siriusArrowUp } from './sirius-arrow-up.icon';
import { siriusArrowsDownUp } from './sirius-arrows-down-up.icon';
import { siriusArrowsIn } from './sirius-arrows-in.icon';
import { siriusArrowsOut } from './sirius-arrows-out.icon';
import { siriusBarbell } from './sirius-barbell.icon';
import { siriusBell } from './sirius-bell.icon';
import { siriusBinoculars } from './sirius-binoculars.icon';
import { siriusBookOpenText } from './sirius-book-open-text.icon';
import { siriusBookmarkSimple } from './sirius-bookmark-simple.icon';
import { siriusBooks } from './sirius-books.icon';
import { siriusBriefcase } from './sirius-briefcase.icon';
import { siriusBug } from './sirius-bug.icon';
import { siriusBullet } from './sirius-bullet.icon';
import { siriusCalendarBlank } from './sirius-calendar-blank.icon';
import { siriusCaretDownSmall } from './sirius-caret-down-small.icon';
import { siriusCaretDown } from './sirius-caret-down.icon';
import { siriusCaretLeftSmall } from './sirius-caret-left-small.icon';
import { siriusCaretLeft } from './sirius-caret-left.icon';
import { siriusCaretRightSmall } from './sirius-caret-right-small.icon';
import { siriusCaretRight } from './sirius-caret-right.icon';
import { siriusCaretUpSmall } from './sirius-caret-up-small.icon';
import { siriusCaretUp } from './sirius-caret-up.icon';
import { siriusChartBarHorizontal } from './sirius-chart-bar-horizontal.icon';
import { siriusChartBarVertical } from './sirius-chart-bar-vertical.icon';
import { siriusChartLineUp } from './sirius-chart-line-up.icon';
import { siriusChatCenteredText } from './sirius-chat-centered-text.icon';
import { siriusChatCentered } from './sirius-chat-centered.icon';
import { siriusChats } from './sirius-chats.icon';
import { siriusCheckCircle } from './sirius-check-circle.icon';
import { siriusCheck } from './sirius-check.icon';
import { siriusCircleHalfTilt } from './sirius-circle-half-tilt.icon';
import { siriusCircleWavyCheck } from './sirius-circle-wavy-check.icon';
import { siriusClipboardPlus } from './sirius-clipboard-plus.icon';
import { siriusClipboardText } from './sirius-clipboard-text.icon';
import { siriusClock } from './sirius-clock.icon';
import { siriusClosedCaptioning } from './sirius-closed-captioning.icon';
import { siriusCloudArrowDown } from './sirius-cloud-arrow-down.icon';
import { siriusCloudArrowUp } from './sirius-cloud-arrow-up.icon';
import { siriusCloudCheck } from './sirius-cloud-check.icon';
import { siriusCloud } from './sirius-cloud.icon';
import { siriusCobotLine } from './sirius-cobot-line.icon';
import { siriusCodepenLogo } from './sirius-codepen-logo.icon';
import { siriusCookie } from './sirius-cookie.icon';
import { siriusCopy } from './sirius-copy.icon';
import { siriusCopyright } from './sirius-copyright.icon';
import { siriusCornersOut } from './sirius-corners-out.icon';
import { siriusCreditCard } from './sirius-credit-card.icon';
import { siriusCrosshair } from './sirius-crosshair.icon';
import { siriusCube } from './sirius-cube.icon';
import { siriusCurrencyDollarSimple } from './sirius-currency-dollar-simple.icon';
import { siriusCylinder } from './sirius-cylinder.icon';
import { siriusDatabase } from './sirius-database.icon';
import { siriusDesktop } from './sirius-desktop.icon';
import { siriusDevice } from './sirius-device.icon';
import { siriusDotsThreeHorisontal } from './sirius-dots-three-horisontal.icon';
import { siriusDotsThreeVertical } from './sirius-dots-three-vertical.icon';
import { siriusDownloadSimple } from './sirius-download-simple.icon';
import { siriusDrop } from './sirius-drop.icon';
import { siriusEnvelopeOpen } from './sirius-envelope-open.icon';
import { siriusEraser } from './sirius-eraser.icon';
import { siriusEyeSlash } from './sirius-eye-slash.icon';
import { siriusEye } from './sirius-eye.icon';
import { siriusFacebookLogo } from './sirius-facebook-logo.icon';
import { siriusFileArrowDown } from './sirius-file-arrow-down.icon';
import { siriusFileArrowUp } from './sirius-file-arrow-up.icon';
import { siriusFileDoc } from './sirius-file-doc.icon';
import { siriusFileHtml } from './sirius-file-html.icon';
import { siriusFileJpg } from './sirius-file-jpg.icon';
import { siriusFilePdf } from './sirius-file-pdf.icon';
import { siriusFilePng } from './sirius-file-png.icon';
import { siriusFilePpt } from './sirius-file-ppt.icon';
import { siriusFileXls } from './sirius-file-xls.icon';
import { siriusFileZip } from './sirius-file-zip.icon';
import { siriusFlame } from './sirius-flame.icon';
import { siriusFlask } from './sirius-flask.icon';
import { siriusForkKnife } from './sirius-fork-knife.icon';
import { siriusFunnelSimple } from './sirius-funnel-simple.icon';
import { siriusFunnel } from './sirius-funnel.icon';
import { siriusGauge } from './sirius-gauge.icon';
import { siriusGear } from './sirius-gear.icon';
import { siriusGhost } from './sirius-ghost.icon';
import { siriusGitBranch } from './sirius-git-branch.icon';
import { siriusGitFork } from './sirius-git-fork.icon';
import { siriusGlobeStand } from './sirius-globe-stand.icon';
import { siriusGlobe } from './sirius-globe.icon';
import { siriusGraduationCap } from './sirius-graduation-cap.icon';
import { siriusGraph } from './sirius-graph.icon';
import { siriusHandsClapping } from './sirius-hands-clapping.icon';
import { siriusHandshake } from './sirius-handshake.icon';
import { siriusHeadset } from './sirius-headset.icon';
import { siriusHeart } from './sirius-heart.icon';
import { siriusHeartbeat } from './sirius-heartbeat.icon';
import { siriusHouse } from './sirius-house.icon';
import { siriusImage } from './sirius-image.icon';
import { siriusInfo } from './sirius-info.icon';
import { siriusInstagramLogo } from './sirius-instagram-logo.icon';
import { siriusLeaf } from './sirius-leaf.icon';
import { siriusLinkBreak } from './sirius-link-break.icon';
import { siriusLink } from './sirius-link.icon';
import { siriusLinkedinLogo } from './sirius-linkedin-logo.icon';
import { siriusListChecks } from './sirius-list-checks.icon';
import { siriusList } from './sirius-list.icon';
import { siriusLockSimpleOpen } from './sirius-lock-simple-open.icon';
import { siriusLockSimple } from './sirius-lock-simple.icon';
import { siriusMagnifyingGlassMinus } from './sirius-magnifying-glass-minus.icon';
import { siriusMagnifyingGlassPlus } from './sirius-magnifying-glass-plus.icon';
import { siriusMagnifyingGlass } from './sirius-magnifying-glass.icon';
import { siriusMapPin } from './sirius-map-pin.icon';
import { siriusMinus } from './sirius-minus.icon';
import { siriusMonitor } from './sirius-monitor.icon';
import { siriusMoon } from './sirius-moon.icon';
import { siriusNeedle } from './sirius-needle.icon';
import { siriusNotepad } from './sirius-notepad.icon';
import { siriusNut } from './sirius-nut.icon';
import { siriusPackage } from './sirius-package.icon';
import { siriusPaintBrushBroad } from './sirius-paint-brush-broad.icon';
import { siriusPaperclipHorizontal } from './sirius-paperclip-horizontal.icon';
import { siriusPaperclip } from './sirius-paperclip.icon';
import { siriusPencilRuler } from './sirius-pencil-ruler.icon';
import { siriusPencil } from './sirius-pencil.icon';
import { siriusPersonSimpleCircle } from './sirius-person-simple-circle.icon';
import { siriusPlayCircle } from './sirius-play-circle.icon';
import { siriusPlugsConnected } from './sirius-plugs-connected.icon';
import { siriusPlugs } from './sirius-plugs.icon';
import { siriusPlus } from './sirius-plus.icon';
import { siriusPrinter } from './sirius-printer.icon';
import { siriusPuzzlePiece } from './sirius-puzzle-piece.icon';
import { siriusQuestion } from './sirius-question.icon';
import { siriusQuotes } from './sirius-quotes.icon';
import { siriusRepeat } from './sirius-repeat.icon';
import { siriusRobot } from './sirius-robot.icon';
import { siriusRocketLaunch } from './sirius-rocket-launch.icon';
import { siriusRows } from './sirius-rows.icon';
import { siriusRuler } from './sirius-ruler.icon';
import { siriusScales } from './sirius-scales.icon';
import { siriusSelectionBackground } from './sirius-selection-background.icon';
import { siriusShareNetwork } from './sirius-share-network.icon';
import { siriusShieldCheck } from './sirius-shield-check.icon';
import { siriusShield } from './sirius-shield.icon';
import { siriusShinpinhaologo } from './sirius-shinpinhaologo.icon';
import { siriusShoppingCart } from './sirius-shopping-cart.icon';
import { siriusShuffleUp } from './sirius-shuffle-up.icon';
import { siriusShuffle } from './sirius-shuffle.icon';
import { siriusSignIn } from './sirius-sign-in.icon';
import { siriusSignOut } from './sirius-sign-out.icon';
import { siriusSlidersHorizontal } from './sirius-sliders-horizontal.icon';
import { siriusSlidersVertical } from './sirius-sliders-vertical.icon';
import { siriusSmalldotsThreeHorisontal } from './sirius-smalldots-three-horisontal.icon';
import { siriusSmalldotsThreeVertical } from './sirius-smalldots-three-vertical.icon';
import { siriusSparkle } from './sirius-sparkle.icon';
import { siriusSpeakerHigh } from './sirius-speaker-high.icon';
import { siriusSpeakerSlash } from './sirius-speaker-slash.icon';
import { siriusSpeakerX } from './sirius-speaker-x.icon';
import { siriusSpeedHigh } from './sirius-speed-high.icon';
import { siriusSpeedLow } from './sirius-speed-low.icon';
import { siriusSpeedMedium } from './sirius-speed-medium.icon';
import { siriusSpotifyLogo } from './sirius-spotify-logo.icon';
import { siriusSquareHalfHorisontal } from './sirius-square-half-horisontal.icon';
import { siriusSquareHalfVertical } from './sirius-square-half-vertical.icon';
import { siriusSquaresFour } from './sirius-squares-four.icon';
import { siriusStack } from './sirius-stack.icon';
import { siriusStamp } from './sirius-stamp.icon';
import { siriusStar } from './sirius-star.icon';
import { siriusSticker } from './sirius-sticker.icon';
import { siriusStudent } from './sirius-student.icon';
import { siriusSun } from './sirius-sun.icon';
import { siriusSwap } from './sirius-swap.icon';
import { siriusSwatches } from './sirius-swatches.icon';
import { siriusSyringe } from './sirius-syringe.icon';
import { siriusTag } from './sirius-tag.icon';
import { siriusTarget } from './sirius-target.icon';
import { siriusTelegramLogo } from './sirius-telegram-logo.icon';
import { siriusTestTube } from './sirius-test-tube.icon';
import { siriusThermometerSimple } from './sirius-thermometer-simple.icon';
import { siriusThumbsDown } from './sirius-thumbs-down.icon';
import { siriusThumbsUp } from './sirius-thumbs-up.icon';
import { siriusTicket } from './sirius-ticket.icon';
import { siriusTiktoklogo } from './sirius-tiktoklogo.icon';
import { siriusTimer } from './sirius-timer.icon';
import { siriusTranslate } from './sirius-translate.icon';
import { siriusTrash } from './sirius-trash.icon';
import { siriusTreeEvergreen } from './sirius-tree-evergreen.icon';
import { siriusTree } from './sirius-tree.icon';
import { siriusTruck } from './sirius-truck.icon';
import { siriusTwitterLogo } from './sirius-twitter-logo.icon';
import { siriusUserCircle } from './sirius-user-circle.icon';
import { siriusUserMinus } from './sirius-user-minus.icon';
import { siriusUserPlus } from './sirius-user-plus.icon';
import { siriusUser } from './sirius-user.icon';
import { siriusUsersFour } from './sirius-users-four.icon';
import { siriusUsersThree } from './sirius-users-three.icon';
import { siriusUsersTwo } from './sirius-users-two.icon';
import { siriusWarningCircle } from './sirius-warning-circle.icon';
import { siriusWechatlogo } from './sirius-wechatlogo.icon';
import { siriusWeishilogo } from './sirius-weishilogo.icon';
import { siriusWorld } from './sirius-world.icon';
import { siriusWrench } from './sirius-wrench.icon';
import { siriusXCircle } from './sirius-x-circle.icon';
import { siriusXLogo } from './sirius-x-logo.icon';
import { siriusX } from './sirius-x.icon';
import { siriusYoutubeLogo } from './sirius-youtube-logo.icon';
import { sirius3DPrintingPictogram } from './sirius-3d-printing-pictogram.icon';
import { siriusAdditionalCostPictogram } from './sirius-additional-cost-pictogram.icon';
import { siriusArchiveBoxLightPictogram } from './sirius-archive-box-light-pictogram.icon';
import { siriusAssemblyPictogram } from './sirius-assembly-pictogram.icon';
import { siriusAwarenessPictogram } from './sirius-awareness-pictogram.icon';
import { siriusBarbellPictogram } from './sirius-barbell-pictogram.icon';
import { siriusBarcodePictogram } from './sirius-barcode-pictogram.icon';
import { siriusBinocularsPictogram } from './sirius-binoculars-pictogram.icon';
import { siriusBuildingsPictogram } from './sirius-buildings-pictogram.icon';
import { siriusCarPictogram } from './sirius-car-pictogram.icon';
import { siriusCertifiedIntegratorPictogram } from './sirius-certified-integrator-pictogram.icon';
import { siriusCertifiedTrainingPartnersPictogram } from './sirius-certified-training-partners-pictogram.icon';
import { siriusChangingDemandsPictogram } from './sirius-changing-demands-pictogram.icon';
import { siriusChatsLightPictogram } from './sirius-chats-light-pictogram.icon';
import { siriusCircleWavyCheckPictogram } from './sirius-circle-wavy-check-pictogram.icon';
import { siriusCobotLinePictogram } from './sirius-cobot-line-pictogram.icon';
import { siriusCobotPictogram } from './sirius-cobot-pictogram.icon';
import { siriusCodeLightPictogram } from './sirius-code-light-pictogram.icon';
import { siriusCollaborativePictogram } from './sirius-collaborative-pictogram.icon';
import { siriusCompetitivePictogram } from './sirius-competitive-pictogram.icon';
import { siriusCompleteSolutionsPictogram } from './sirius-complete-solutions-pictogram.icon';
import { siriusComponentsPictogram } from './sirius-components-pictogram.icon';
import { siriusComputerTowerLightPictogram } from './sirius-computer-tower-light-pictogram.icon';
import { siriusCostEffectivePictogram } from './sirius-cost-effective-pictogram.icon';
import { siriusCurrencyBtcLightPictogram } from './sirius-currency-btc-light-pictogram.icon';
import { siriusCustomerSuccessPictogram } from './sirius-customer-success-pictogram.icon';
import { siriusDifficultSetupPictogram } from './sirius-difficult-setup-pictogram.icon';
import { siriusDistributorsPictogram } from './sirius-distributors-pictogram.icon';
import { siriusDropHalfLightPictogram } from './sirius-drop-half-light-pictogram.icon';
import { siriusELearningPictogram } from './sirius-e-learning-pictogram.icon';
import { siriusExpertPictogram } from './sirius-expert-pictogram.icon';
import { siriusFaceMaskLightPictogram } from './sirius-face-mask-light-pictogram.icon';
import { siriusFactoryPictogram } from './sirius-factory-pictogram.icon';
import { siriusFilePdfPictogram } from './sirius-file-pdf-pictogram.icon';
import { siriusFinishingPictogram } from './sirius-finishing-pictogram.icon';
import { siriusFlaskPictogram } from './sirius-flask-pictogram.icon';
import { siriusGearLightPictogram } from './sirius-gear-light-pictogram.icon';
import { siriusGlobalEcosystemPictogram } from './sirius-global-ecosystem-pictogram.icon';
import { siriusGlobeHemisphereWestPictogram } from './sirius-globe-hemisphere-west-pictogram.icon';
import { siriusGlobeStandPictogram } from './sirius-globe-stand-pictogram.icon';
import { siriusGlueingDispensingPictogram } from './sirius-glueing-dispensing-pictogram.icon';
import { siriusHamburgerPictogram } from './sirius-hamburger-pictogram.icon';
import { siriusHeartbeatLightPictogram } from './sirius-heartbeat-light-pictogram.icon';
import { siriusIiotPictogram } from './sirius-iiot-pictogram.icon';
import { siriusIncreasedCompetitionPictogram } from './sirius-increased-competition-pictogram.icon';
import { siriusIndustry5Pictogram } from './sirius-industry-5-pictogram.icon';
import { siriusInjectionMoldingPictogram } from './sirius-injection-molding-pictogram.icon';
import { siriusIotPictogram } from './sirius-iot-pictogram.icon';
import { siriusLabourShortagePictogram } from './sirius-labour-shortage-pictogram.icon';
import { siriusMachineTendingPictogram } from './sirius-machine-tending-pictogram.icon';
import { siriusMapPinLinePictogram } from './sirius-map-pin-line-pictogram.icon';
import { siriusMapPinPictogram } from './sirius-map-pin-pictogram.icon';
import { siriusMaterialHandlingOldPictogram } from './sirius-material-handling-old-pictogram.icon';
import { siriusMaterialHandlingPictogram } from './sirius-material-handling-pictogram.icon';
import { siriusMaterialRemovalPictogram } from './sirius-material-removal-pictogram.icon';
import { siriusNewbizzPictogram } from './sirius-newbizz-pictogram.icon';
import { siriusNutPictogram } from './sirius-nut-pictogram.icon';
import { siriusOnlineTrainingPictogram } from './sirius-online-training-pictogram.icon';
import { siriusPalletizingOldPictogram } from './sirius-palletizing-old-pictogram.icon';
import { siriusPalletizingPackagingPictogram } from './sirius-palletizing-packaging-pictogram.icon';
import { siriusPalletizingPictogram } from './sirius-palletizing-pictogram.icon';
import { siriusPickPlacePictogram } from './sirius-pick-place-pictogram.icon';
import { siriusPlanetPictogram } from './sirius-planet-pictogram.icon';
import { siriusPostPurchasePictogram } from './sirius-post-purchase-pictogram.icon';
import { siriusPrecisionPictogram } from './sirius-precision-pictogram.icon';
import { siriusPredictiveMaintenancePictogram } from './sirius-predictive-maintenance-pictogram.icon';
import { siriusProductivePictogram } from './sirius-productive-pictogram.icon';
import { siriusProjectorScreenPictogram } from './sirius-projector-screen-pictogram.icon';
import { siriusQualityInspectionPictogram } from './sirius-quality-inspection-pictogram.icon';
import { siriusQuotesPictogram } from './sirius-quotes-pictogram.icon';
import { siriusRetentionPictogram } from './sirius-retention-pictogram.icon';
import { siriusRiskAssessmentPictogram } from './sirius-risk-assessment-pictogram.icon';
import { siriusRobotPictogram } from './sirius-robot-pictogram.icon';
import { siriusRulerPictogram } from './sirius-ruler-pictogram.icon';
import { siriusSafetyHelmetPictogram } from './sirius-safety-helmet-pictogram.icon';
import { siriusScalesPictogram } from './sirius-scales-pictogram.icon';
import { siriusScrewdriverPictogram } from './sirius-screwdriver-pictogram.icon';
import { siriusServicesPictogram } from './sirius-services-pictogram.icon';
import { siriusSignpostPictogram } from './sirius-signpost-pictogram.icon';
import { siriusSimCardPictogram } from './sirius-sim-card-pictogram.icon';
import { siriusSlidersHorizontalLightPictogram } from './sirius-sliders-horizontal-light-pictogram.icon';
import { siriusSpaceRequirementsPictogram } from './sirius-space-requirements-pictogram.icon';
import { siriusSparklePictogram } from './sirius-sparkle-pictogram.icon';
import { siriusStarPictogram } from './sirius-star-pictogram.icon';
import { siriusStraightforwardPictogram } from './sirius-straightforward-pictogram.icon';
import { siriusSupplyChainPictogram } from './sirius-supply-chain-pictogram.icon';
import { siriusTargetLightPictogram } from './sirius-target-light-pictogram.icon';
import { siriusTimerLightPictogram } from './sirius-timer-light-pictogram.icon';
import { siriusUserGearLightPictogram } from './sirius-user-gear-light-pictogram.icon';
import { siriusUserListPictogram } from './sirius-user-list-pictogram.icon';
import { siriusUsersThreePictogram } from './sirius-users-three-pictogram.icon';
import { siriusWarningLightPictogram } from './sirius-warning-light-pictogram.icon';
import { siriusWeldingPictogram } from './sirius-welding-pictogram.icon';
import { siriusWrenchPictogram } from './sirius-wrench-pictogram.icon';
import { siriusXCirclePictogram } from './sirius-x-circle-pictogram.icon';
export const completeIconSet: SiriusIcon[] = [
  siriusApplePodcastsLogoDuotone as SiriusIcon,
  siriusArrowFatLinesRightDuotone as SiriusIcon,
  siriusBarbellDuotone as SiriusIcon,
  siriusBarcodeDuotone as SiriusIcon,
  siriusBellDuotone as SiriusIcon,
  siriusBinocularsDuotone as SiriusIcon,
  siriusBookOpenTextDuotone as SiriusIcon,
  siriusBookmarkSimpleDuotone as SiriusIcon,
  siriusBooksDuotone as SiriusIcon,
  siriusBriefcaseDuotone as SiriusIcon,
  siriusBugDuotone as SiriusIcon,
  siriusCalendarBlankDuotone as SiriusIcon,
  siriusChartBarHorizontalDuotone as SiriusIcon,
  siriusChartBarVerticalDuotone as SiriusIcon,
  siriusChartLineUpDuotone as SiriusIcon,
  siriusChatCenteredDuotone as SiriusIcon,
  siriusChatCenteredTextDuotone as SiriusIcon,
  siriusChatsDuotone as SiriusIcon,
  siriusCheckCircleDuotone as SiriusIcon,
  siriusCircleHalfTiltDuotone as SiriusIcon,
  siriusClipboardPlusDuotone as SiriusIcon,
  siriusClipboardTextDuotone as SiriusIcon,
  siriusClockDuotone as SiriusIcon,
  siriusClosedCaptioningDuotone as SiriusIcon,
  siriusCloudArrowDownDuotone as SiriusIcon,
  siriusCloudArrowUpDuotone as SiriusIcon,
  siriusCloudCheckDuotone as SiriusIcon,
  siriusCloudDuotone as SiriusIcon,
  siriusCobotLineDuotone as SiriusIcon,
  siriusCodepenLogoDuotone as SiriusIcon,
  siriusCookieDuotone as SiriusIcon,
  siriusCopyDuotone as SiriusIcon,
  siriusCopyrightDuotone as SiriusIcon,
  siriusCreditCardDuotone as SiriusIcon,
  siriusCropDuotone as SiriusIcon,
  siriusCrosshairDuotone as SiriusIcon,
  siriusCubeDuotone as SiriusIcon,
  siriusCurrencyDollarSimpleDuotone as SiriusIcon,
  siriusCylinderDuotone as SiriusIcon,
  siriusDatabaseDuotone as SiriusIcon,
  siriusDesktopDuotone as SiriusIcon,
  siriusDeviceDuotone as SiriusIcon,
  siriusDotsThreeHorisontalDuotone as SiriusIcon,
  siriusDotsThreeVerticalDuotone as SiriusIcon,
  siriusDropDuotone as SiriusIcon,
  siriusEnvelopeOpenDuotone as SiriusIcon,
  siriusEraserDuotone as SiriusIcon,
  siriusEyeDuotone as SiriusIcon,
  siriusEyeSlashDuotone as SiriusIcon,
  siriusEyecClosedDuotone as SiriusIcon,
  siriusFacebookLogoDuotone as SiriusIcon,
  siriusFileArrowDownDuotone as SiriusIcon,
  siriusFileArrowUpDuotone as SiriusIcon,
  siriusFileDocDuotone as SiriusIcon,
  siriusFileHtmlDuotone as SiriusIcon,
  siriusFileJpgDuotone as SiriusIcon,
  siriusFilePdfDuotone as SiriusIcon,
  siriusFilePngDuotone as SiriusIcon,
  siriusFilePptDuotone as SiriusIcon,
  siriusFileXlsDuotone as SiriusIcon,
  siriusFileZipDuotone as SiriusIcon,
  siriusFlameDuotone as SiriusIcon,
  siriusFlaskDuotone as SiriusIcon,
  siriusForkKnifeDuotone as SiriusIcon,
  siriusFunnelDuotone as SiriusIcon,
  siriusGaugeDuotone as SiriusIcon,
  siriusGearDuotone as SiriusIcon,
  siriusGhostDuotone as SiriusIcon,
  siriusGitBranchDuotone as SiriusIcon,
  siriusGitForkDuotone as SiriusIcon,
  siriusGlobeDuotone as SiriusIcon,
  siriusGlobeStandDuotone as SiriusIcon,
  siriusGraduationCapDuotone as SiriusIcon,
  siriusGraphDuotone as SiriusIcon,
  siriusHandshakeDuotone as SiriusIcon,
  siriusHeadsetDuotone as SiriusIcon,
  siriusHeartDuotone as SiriusIcon,
  siriusHeartbeatDuotone as SiriusIcon,
  siriusHouseDuotone as SiriusIcon,
  siriusImageDuotone as SiriusIcon,
  siriusInfoDuotone as SiriusIcon,
  siriusInstagramLogoDuotone as SiriusIcon,
  siriusLeafDuotone as SiriusIcon,
  siriusLinkedinLogoDuotone as SiriusIcon,
  siriusListBulletsDuotone as SiriusIcon,
  siriusListChecksDuotone as SiriusIcon,
  siriusListPlusDuotone as SiriusIcon,
  siriusLockSimpleDuotone as SiriusIcon,
  siriusLockSimpleOpenDuotone as SiriusIcon,
  siriusMagnifyingGlassDuotone as SiriusIcon,
  siriusMagnifyingGlassMinusDuotone as SiriusIcon,
  siriusMagnifyingGlassPlusDuotone as SiriusIcon,
  siriusMapPinDuotone as SiriusIcon,
  siriusMonitorDuotone as SiriusIcon,
  siriusMoonDuotone as SiriusIcon,
  siriusNeedleDuotone as SiriusIcon,
  siriusNotepadDuotone as SiriusIcon,
  siriusNutDuotone as SiriusIcon,
  siriusPackageDuotone as SiriusIcon,
  siriusPaintBrushBroadDuotone as SiriusIcon,
  siriusPencilDuotone as SiriusIcon,
  siriusPencilRulerDuotone as SiriusIcon,
  siriusPersonSimpleCircleDuotone as SiriusIcon,
  siriusPlayCircleDuotone as SiriusIcon,
  siriusPlugsConnectedDuotone as SiriusIcon,
  siriusPlugsDuotone as SiriusIcon,
  siriusPrinterDuotone as SiriusIcon,
  siriusQuestionDuotone as SiriusIcon,
  siriusQuotesDuotone as SiriusIcon,
  siriusRepeatDuotone as SiriusIcon,
  siriusRobotDuotone as SiriusIcon,
  siriusRocketLaunchDuotone as SiriusIcon,
  siriusRowsDuotone as SiriusIcon,
  siriusRulerDuotone as SiriusIcon,
  siriusScalesDuotone as SiriusIcon,
  siriusSelectionBackgroundDuotone as SiriusIcon,
  siriusShareNetworkDuotone as SiriusIcon,
  siriusShieldCheckDuotone as SiriusIcon,
  siriusShieldDuotone as SiriusIcon,
  siriusShipinhaoLogoDuotone as SiriusIcon,
  siriusShoppingCartDuotone as SiriusIcon,
  siriusShuffleDuotone as SiriusIcon,
  siriusShuffleUpDuotone as SiriusIcon,
  siriusSlidersHorizontalDuotone as SiriusIcon,
  siriusSlidersVerticalDuotone as SiriusIcon,
  siriusSmalldotsThreeHorisontalDuotone as SiriusIcon,
  siriusSmalldotsThreeVerticalDuotone as SiriusIcon,
  siriusSparkleDuotone as SiriusIcon,
  siriusSpeakerHighDuotone as SiriusIcon,
  siriusSpeakerSlashDuotone as SiriusIcon,
  siriusSpeakerXDuotone as SiriusIcon,
  siriusSpeedHighDuotone as SiriusIcon,
  siriusSpeedLowDuotone as SiriusIcon,
  siriusSpeedMediumDuotone as SiriusIcon,
  siriusSpotifyLogoDuotone as SiriusIcon,
  siriusSquareHalfHorisontalDuotone as SiriusIcon,
  siriusSquareHalfVerticalDuotone as SiriusIcon,
  siriusSquaresFourDuotone as SiriusIcon,
  siriusStackDuotone as SiriusIcon,
  siriusStampDuotone as SiriusIcon,
  siriusStarDuotone as SiriusIcon,
  siriusStickerDuotone as SiriusIcon,
  siriusStudentDuotone as SiriusIcon,
  siriusSunDuotone as SiriusIcon,
  siriusSwapDuotone as SiriusIcon,
  siriusSwatchesDuotone as SiriusIcon,
  siriusSyringeDuotone as SiriusIcon,
  siriusTagDuotone as SiriusIcon,
  siriusTargetDuotone as SiriusIcon,
  siriusTelegramLogoDuotone as SiriusIcon,
  siriusTestTubeDuotone as SiriusIcon,
  siriusThermometerSimpleDuotone as SiriusIcon,
  siriusThumbsDownDuotone as SiriusIcon,
  siriusThumbsUpDuotone as SiriusIcon,
  siriusTicketDuotone as SiriusIcon,
  siriusTiktokLogoDuotone as SiriusIcon,
  siriusTimerDuotone as SiriusIcon,
  siriusTrashDuotone as SiriusIcon,
  siriusTreeDuotone as SiriusIcon,
  siriusTreeEvergreenDuotone as SiriusIcon,
  siriusTruckDuotone as SiriusIcon,
  siriusTwitterLogoDuotone as SiriusIcon,
  siriusUserCircleDuotone as SiriusIcon,
  siriusUserDuotone as SiriusIcon,
  siriusUserMinusDuotone as SiriusIcon,
  siriusUserPlusDuotone as SiriusIcon,
  siriusUsersFourDuotone as SiriusIcon,
  siriusUsersThreeDuotone as SiriusIcon,
  siriusUsersTwoDuotone as SiriusIcon,
  siriusWarningCircleDuotone as SiriusIcon,
  siriusWechatLogoDuotone as SiriusIcon,
  siriusWeishiLogoDuotone as SiriusIcon,
  siriusWorldDuotone as SiriusIcon,
  siriusWrenchDuotone as SiriusIcon,
  siriusXCircleDuotone as SiriusIcon,
  siriusXLogoDuotone as SiriusIcon,
  siriusYoutubeLogoDuotone as SiriusIcon,
  siriusApplePodcastsLogo as SiriusIcon,
  siriusArrowDownLeftSmall as SiriusIcon,
  siriusArrowDownLeft as SiriusIcon,
  siriusArrowDownRightSmall as SiriusIcon,
  siriusArrowDownRight as SiriusIcon,
  siriusArrowDownSmall as SiriusIcon,
  siriusArrowDown as SiriusIcon,
  siriusArrowFatLinesRight as SiriusIcon,
  siriusArrowLeftSmall as SiriusIcon,
  siriusArrowLeft as SiriusIcon,
  siriusArrowRightSmall as SiriusIcon,
  siriusArrowRight as SiriusIcon,
  siriusArrowSquareIn as SiriusIcon,
  siriusArrowSquareOut as SiriusIcon,
  siriusArrowUpLeftSmall as SiriusIcon,
  siriusArrowUpLeft as SiriusIcon,
  siriusArrowUpRightSmall as SiriusIcon,
  siriusArrowUpRight as SiriusIcon,
  siriusArrowUpSmall as SiriusIcon,
  siriusArrowUp as SiriusIcon,
  siriusArrowsDownUp as SiriusIcon,
  siriusArrowsIn as SiriusIcon,
  siriusArrowsOut as SiriusIcon,
  siriusBarbell as SiriusIcon,
  siriusBell as SiriusIcon,
  siriusBinoculars as SiriusIcon,
  siriusBookOpenText as SiriusIcon,
  siriusBookmarkSimple as SiriusIcon,
  siriusBooks as SiriusIcon,
  siriusBriefcase as SiriusIcon,
  siriusBug as SiriusIcon,
  siriusBullet as SiriusIcon,
  siriusCalendarBlank as SiriusIcon,
  siriusCaretDownSmall as SiriusIcon,
  siriusCaretDown as SiriusIcon,
  siriusCaretLeftSmall as SiriusIcon,
  siriusCaretLeft as SiriusIcon,
  siriusCaretRightSmall as SiriusIcon,
  siriusCaretRight as SiriusIcon,
  siriusCaretUpSmall as SiriusIcon,
  siriusCaretUp as SiriusIcon,
  siriusChartBarHorizontal as SiriusIcon,
  siriusChartBarVertical as SiriusIcon,
  siriusChartLineUp as SiriusIcon,
  siriusChatCenteredText as SiriusIcon,
  siriusChatCentered as SiriusIcon,
  siriusChats as SiriusIcon,
  siriusCheckCircle as SiriusIcon,
  siriusCheck as SiriusIcon,
  siriusCircleHalfTilt as SiriusIcon,
  siriusCircleWavyCheck as SiriusIcon,
  siriusClipboardPlus as SiriusIcon,
  siriusClipboardText as SiriusIcon,
  siriusClock as SiriusIcon,
  siriusClosedCaptioning as SiriusIcon,
  siriusCloudArrowDown as SiriusIcon,
  siriusCloudArrowUp as SiriusIcon,
  siriusCloudCheck as SiriusIcon,
  siriusCloud as SiriusIcon,
  siriusCobotLine as SiriusIcon,
  siriusCodepenLogo as SiriusIcon,
  siriusCookie as SiriusIcon,
  siriusCopy as SiriusIcon,
  siriusCopyright as SiriusIcon,
  siriusCornersOut as SiriusIcon,
  siriusCreditCard as SiriusIcon,
  siriusCrosshair as SiriusIcon,
  siriusCube as SiriusIcon,
  siriusCurrencyDollarSimple as SiriusIcon,
  siriusCylinder as SiriusIcon,
  siriusDatabase as SiriusIcon,
  siriusDesktop as SiriusIcon,
  siriusDevice as SiriusIcon,
  siriusDotsThreeHorisontal as SiriusIcon,
  siriusDotsThreeVertical as SiriusIcon,
  siriusDownloadSimple as SiriusIcon,
  siriusDrop as SiriusIcon,
  siriusEnvelopeOpen as SiriusIcon,
  siriusEraser as SiriusIcon,
  siriusEyeSlash as SiriusIcon,
  siriusEye as SiriusIcon,
  siriusFacebookLogo as SiriusIcon,
  siriusFileArrowDown as SiriusIcon,
  siriusFileArrowUp as SiriusIcon,
  siriusFileDoc as SiriusIcon,
  siriusFileHtml as SiriusIcon,
  siriusFileJpg as SiriusIcon,
  siriusFilePdf as SiriusIcon,
  siriusFilePng as SiriusIcon,
  siriusFilePpt as SiriusIcon,
  siriusFileXls as SiriusIcon,
  siriusFileZip as SiriusIcon,
  siriusFlame as SiriusIcon,
  siriusFlask as SiriusIcon,
  siriusForkKnife as SiriusIcon,
  siriusFunnelSimple as SiriusIcon,
  siriusFunnel as SiriusIcon,
  siriusGauge as SiriusIcon,
  siriusGear as SiriusIcon,
  siriusGhost as SiriusIcon,
  siriusGitBranch as SiriusIcon,
  siriusGitFork as SiriusIcon,
  siriusGlobeStand as SiriusIcon,
  siriusGlobe as SiriusIcon,
  siriusGraduationCap as SiriusIcon,
  siriusGraph as SiriusIcon,
  siriusHandsClapping as SiriusIcon,
  siriusHandshake as SiriusIcon,
  siriusHeadset as SiriusIcon,
  siriusHeart as SiriusIcon,
  siriusHeartbeat as SiriusIcon,
  siriusHouse as SiriusIcon,
  siriusImage as SiriusIcon,
  siriusInfo as SiriusIcon,
  siriusInstagramLogo as SiriusIcon,
  siriusLeaf as SiriusIcon,
  siriusLinkBreak as SiriusIcon,
  siriusLink as SiriusIcon,
  siriusLinkedinLogo as SiriusIcon,
  siriusListChecks as SiriusIcon,
  siriusList as SiriusIcon,
  siriusLockSimpleOpen as SiriusIcon,
  siriusLockSimple as SiriusIcon,
  siriusMagnifyingGlassMinus as SiriusIcon,
  siriusMagnifyingGlassPlus as SiriusIcon,
  siriusMagnifyingGlass as SiriusIcon,
  siriusMapPin as SiriusIcon,
  siriusMinus as SiriusIcon,
  siriusMonitor as SiriusIcon,
  siriusMoon as SiriusIcon,
  siriusNeedle as SiriusIcon,
  siriusNotepad as SiriusIcon,
  siriusNut as SiriusIcon,
  siriusPackage as SiriusIcon,
  siriusPaintBrushBroad as SiriusIcon,
  siriusPaperclipHorizontal as SiriusIcon,
  siriusPaperclip as SiriusIcon,
  siriusPencilRuler as SiriusIcon,
  siriusPencil as SiriusIcon,
  siriusPersonSimpleCircle as SiriusIcon,
  siriusPlayCircle as SiriusIcon,
  siriusPlugsConnected as SiriusIcon,
  siriusPlugs as SiriusIcon,
  siriusPlus as SiriusIcon,
  siriusPrinter as SiriusIcon,
  siriusPuzzlePiece as SiriusIcon,
  siriusQuestion as SiriusIcon,
  siriusQuotes as SiriusIcon,
  siriusRepeat as SiriusIcon,
  siriusRobot as SiriusIcon,
  siriusRocketLaunch as SiriusIcon,
  siriusRows as SiriusIcon,
  siriusRuler as SiriusIcon,
  siriusScales as SiriusIcon,
  siriusSelectionBackground as SiriusIcon,
  siriusShareNetwork as SiriusIcon,
  siriusShieldCheck as SiriusIcon,
  siriusShield as SiriusIcon,
  siriusShinpinhaologo as SiriusIcon,
  siriusShoppingCart as SiriusIcon,
  siriusShuffleUp as SiriusIcon,
  siriusShuffle as SiriusIcon,
  siriusSignIn as SiriusIcon,
  siriusSignOut as SiriusIcon,
  siriusSlidersHorizontal as SiriusIcon,
  siriusSlidersVertical as SiriusIcon,
  siriusSmalldotsThreeHorisontal as SiriusIcon,
  siriusSmalldotsThreeVertical as SiriusIcon,
  siriusSparkle as SiriusIcon,
  siriusSpeakerHigh as SiriusIcon,
  siriusSpeakerSlash as SiriusIcon,
  siriusSpeakerX as SiriusIcon,
  siriusSpeedHigh as SiriusIcon,
  siriusSpeedLow as SiriusIcon,
  siriusSpeedMedium as SiriusIcon,
  siriusSpotifyLogo as SiriusIcon,
  siriusSquareHalfHorisontal as SiriusIcon,
  siriusSquareHalfVertical as SiriusIcon,
  siriusSquaresFour as SiriusIcon,
  siriusStack as SiriusIcon,
  siriusStamp as SiriusIcon,
  siriusStar as SiriusIcon,
  siriusSticker as SiriusIcon,
  siriusStudent as SiriusIcon,
  siriusSun as SiriusIcon,
  siriusSwap as SiriusIcon,
  siriusSwatches as SiriusIcon,
  siriusSyringe as SiriusIcon,
  siriusTag as SiriusIcon,
  siriusTarget as SiriusIcon,
  siriusTelegramLogo as SiriusIcon,
  siriusTestTube as SiriusIcon,
  siriusThermometerSimple as SiriusIcon,
  siriusThumbsDown as SiriusIcon,
  siriusThumbsUp as SiriusIcon,
  siriusTicket as SiriusIcon,
  siriusTiktoklogo as SiriusIcon,
  siriusTimer as SiriusIcon,
  siriusTranslate as SiriusIcon,
  siriusTrash as SiriusIcon,
  siriusTreeEvergreen as SiriusIcon,
  siriusTree as SiriusIcon,
  siriusTruck as SiriusIcon,
  siriusTwitterLogo as SiriusIcon,
  siriusUserCircle as SiriusIcon,
  siriusUserMinus as SiriusIcon,
  siriusUserPlus as SiriusIcon,
  siriusUser as SiriusIcon,
  siriusUsersFour as SiriusIcon,
  siriusUsersThree as SiriusIcon,
  siriusUsersTwo as SiriusIcon,
  siriusWarningCircle as SiriusIcon,
  siriusWechatlogo as SiriusIcon,
  siriusWeishilogo as SiriusIcon,
  siriusWorld as SiriusIcon,
  siriusWrench as SiriusIcon,
  siriusXCircle as SiriusIcon,
  siriusXLogo as SiriusIcon,
  siriusX as SiriusIcon,
  siriusYoutubeLogo as SiriusIcon,
  sirius3DPrintingPictogram as SiriusIcon,
  siriusAdditionalCostPictogram as SiriusIcon,
  siriusArchiveBoxLightPictogram as SiriusIcon,
  siriusAssemblyPictogram as SiriusIcon,
  siriusAwarenessPictogram as SiriusIcon,
  siriusBarbellPictogram as SiriusIcon,
  siriusBarcodePictogram as SiriusIcon,
  siriusBinocularsPictogram as SiriusIcon,
  siriusBuildingsPictogram as SiriusIcon,
  siriusCarPictogram as SiriusIcon,
  siriusCertifiedIntegratorPictogram as SiriusIcon,
  siriusCertifiedTrainingPartnersPictogram as SiriusIcon,
  siriusChangingDemandsPictogram as SiriusIcon,
  siriusChatsLightPictogram as SiriusIcon,
  siriusCircleWavyCheckPictogram as SiriusIcon,
  siriusCobotLinePictogram as SiriusIcon,
  siriusCobotPictogram as SiriusIcon,
  siriusCodeLightPictogram as SiriusIcon,
  siriusCollaborativePictogram as SiriusIcon,
  siriusCompetitivePictogram as SiriusIcon,
  siriusCompleteSolutionsPictogram as SiriusIcon,
  siriusComponentsPictogram as SiriusIcon,
  siriusComputerTowerLightPictogram as SiriusIcon,
  siriusCostEffectivePictogram as SiriusIcon,
  siriusCurrencyBtcLightPictogram as SiriusIcon,
  siriusCustomerSuccessPictogram as SiriusIcon,
  siriusDifficultSetupPictogram as SiriusIcon,
  siriusDistributorsPictogram as SiriusIcon,
  siriusDropHalfLightPictogram as SiriusIcon,
  siriusELearningPictogram as SiriusIcon,
  siriusExpertPictogram as SiriusIcon,
  siriusFaceMaskLightPictogram as SiriusIcon,
  siriusFactoryPictogram as SiriusIcon,
  siriusFilePdfPictogram as SiriusIcon,
  siriusFinishingPictogram as SiriusIcon,
  siriusFlaskPictogram as SiriusIcon,
  siriusGearLightPictogram as SiriusIcon,
  siriusGlobalEcosystemPictogram as SiriusIcon,
  siriusGlobeHemisphereWestPictogram as SiriusIcon,
  siriusGlobeStandPictogram as SiriusIcon,
  siriusGlueingDispensingPictogram as SiriusIcon,
  siriusHamburgerPictogram as SiriusIcon,
  siriusHeartbeatLightPictogram as SiriusIcon,
  siriusIiotPictogram as SiriusIcon,
  siriusIncreasedCompetitionPictogram as SiriusIcon,
  siriusIndustry5Pictogram as SiriusIcon,
  siriusInjectionMoldingPictogram as SiriusIcon,
  siriusIotPictogram as SiriusIcon,
  siriusLabourShortagePictogram as SiriusIcon,
  siriusMachineTendingPictogram as SiriusIcon,
  siriusMapPinLinePictogram as SiriusIcon,
  siriusMapPinPictogram as SiriusIcon,
  siriusMaterialHandlingOldPictogram as SiriusIcon,
  siriusMaterialHandlingPictogram as SiriusIcon,
  siriusMaterialRemovalPictogram as SiriusIcon,
  siriusNewbizzPictogram as SiriusIcon,
  siriusNutPictogram as SiriusIcon,
  siriusOnlineTrainingPictogram as SiriusIcon,
  siriusPalletizingOldPictogram as SiriusIcon,
  siriusPalletizingPackagingPictogram as SiriusIcon,
  siriusPalletizingPictogram as SiriusIcon,
  siriusPickPlacePictogram as SiriusIcon,
  siriusPlanetPictogram as SiriusIcon,
  siriusPostPurchasePictogram as SiriusIcon,
  siriusPrecisionPictogram as SiriusIcon,
  siriusPredictiveMaintenancePictogram as SiriusIcon,
  siriusProductivePictogram as SiriusIcon,
  siriusProjectorScreenPictogram as SiriusIcon,
  siriusQualityInspectionPictogram as SiriusIcon,
  siriusQuotesPictogram as SiriusIcon,
  siriusRetentionPictogram as SiriusIcon,
  siriusRiskAssessmentPictogram as SiriusIcon,
  siriusRobotPictogram as SiriusIcon,
  siriusRulerPictogram as SiriusIcon,
  siriusSafetyHelmetPictogram as SiriusIcon,
  siriusScalesPictogram as SiriusIcon,
  siriusScrewdriverPictogram as SiriusIcon,
  siriusServicesPictogram as SiriusIcon,
  siriusSignpostPictogram as SiriusIcon,
  siriusSimCardPictogram as SiriusIcon,
  siriusSlidersHorizontalLightPictogram as SiriusIcon,
  siriusSpaceRequirementsPictogram as SiriusIcon,
  siriusSparklePictogram as SiriusIcon,
  siriusStarPictogram as SiriusIcon,
  siriusStraightforwardPictogram as SiriusIcon,
  siriusSupplyChainPictogram as SiriusIcon,
  siriusTargetLightPictogram as SiriusIcon,
  siriusTimerLightPictogram as SiriusIcon,
  siriusUserGearLightPictogram as SiriusIcon,
  siriusUserListPictogram as SiriusIcon,
  siriusUsersThreePictogram as SiriusIcon,
  siriusWarningLightPictogram as SiriusIcon,
  siriusWeldingPictogram as SiriusIcon,
  siriusWrenchPictogram as SiriusIcon,
  siriusXCirclePictogram as SiriusIcon
];
